/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_ActiveInputs */

const he_account_notifications_active = /** @type {(inputs: Account_Notifications_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעיל`)
};

const en_account_notifications_active = /** @type {(inputs: Account_Notifications_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Account_Notifications_ActiveInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_active = /** @type {((inputs?: Account_Notifications_ActiveInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_ActiveInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_active(inputs)
	return en_account_notifications_active(inputs)
});